"use client";
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "@/components/shadcn/tabs";
import BizeYazin from "@/components/support-sections/bize-yazin";
import Guvenlik from "@/components/support-sections/guvenlik";
import OnerideBulunun from "@/components/support-sections/oneride-bulunun";
import PremiumUyelik from "@/components/support-sections/premium-uyelik";
import Profil from "@/components/support-sections/profil";
import UnvanliOyuncular from "@/components/support-sections/unvanli-oyuncular";
import VideoDosyalari from "@/components/support-sections/video-dosyalari";
import { useRouter } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

export default function SupportPageClient({
    params,
}: {
    params: { slug: string };
}) {
    const t = useTranslations("help");

    const router = useRouter();

    const handleTabChange = (value: string) => {
        // update the URL query parameter
        if (value == "hakkimizda") {
            router.push("/hakkimizda");
        } else {
            router.push("/yardim/" + value);
        }
    };

    return (
        <div className="w-full">
            <div className="flex justify-center">
                <style jsx>{`
                    h1 {
                        margin: 50px;
                        color: rgb(24, 16, 89);
                        line-height: 72px;
                    }
                `}</style>

                <h1 className="w-[60%] text-center text-[64px] font-bold">
                    {t("title")}
                </h1>
            </div>
            <div className="flex justify-center">
                <Tabs
                    defaultValue={params.slug}
                    className="w-full text-center"
                    onValueChange={handleTabChange}
                >
                    <TabsList>
                        <TabsTrigger className="text-[16px]" value="profil">
                            {t("profile")}
                        </TabsTrigger>
                        <TabsTrigger
                            className="text-[16px]"
                            value="video-dosyalari"
                        >
                            {t("videoFiles")}
                        </TabsTrigger>
                        <TabsTrigger
                            className="text-[16px]"
                            value="premium-uyelik"
                        >
                            {t("premium")}
                        </TabsTrigger>
                        <TabsTrigger
                            className="text-[16px]"
                            value="unvanli-oyuncular"
                        >
                            {t("titledPlayers")}
                        </TabsTrigger>
                        <TabsTrigger className="text-[16px]" value="guvenlik">
                            {t("security")}
                        </TabsTrigger>
                        <TabsTrigger
                            className="text-[16px]"
                            value="oneride-bulunun"
                        >
                            {t("suggest")}
                        </TabsTrigger>
                        <TabsTrigger className="text-[16px]" value="bize-yazin">
                            {t("writeUs")}
                        </TabsTrigger>
                        <TabsTrigger className="text-[16px]" value="hakkimizda">
                            {t("about")}
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value="profil">
                        <Profil />
                    </TabsContent>
                    <TabsContent value="video-dosyalari">
                        <VideoDosyalari />
                    </TabsContent>
                    <TabsContent value="premium-uyelik">
                        <PremiumUyelik />
                    </TabsContent>
                    <TabsContent value="unvanli-oyuncular">
                        <UnvanliOyuncular />
                    </TabsContent>
                    <TabsContent value="guvenlik">
                        <Guvenlik />
                    </TabsContent>
                    <TabsContent value="oneride-bulunun">
                        <OnerideBulunun />
                    </TabsContent>
                    <TabsContent value="bize-yazin">
                        <BizeYazin />
                    </TabsContent>
                    <TabsContent value="hakkimizda">{t("about")}</TabsContent>
                </Tabs>
            </div>
        </div>
    );
}
